// extracted by mini-css-extract-plugin
export default {"modal":"AICancelConfirmModal_modal__b3azO"};